import React from "react";

import { Drawer } from "src/components/drawer";
import { ErrorNotification } from "src/components/errorNotification";
import { withShowToggle } from "src/components/hoc/withShowToggle";
import { ApiError } from "src/core/apiError";
import { ActivityEvent, CandidateReview } from "src/gen/schema/configd/api";

import { PreviewChanges } from "./previewChanges";

import "./previewChanges.scss";

/**
 * Base interface for all candidate types
 * Ensures candidates have the required properties for preview
 */
export interface BaseCandidate {
  readonly events: ActivityEvent[];
  readonly txnId: string;
  readonly reviews: CandidateReview[];
}

interface ChangeDrawerProps<T extends BaseCandidate> {
  readonly title: string | React.ReactNode;
  readonly onClose: () => void;
  readonly isOpen: boolean;
  readonly candidate: T | undefined;
  readonly loading?: boolean;
  readonly error?: ApiError;
  readonly children?: React.ReactNode | React.ReactNode[];
}

export const CandidateChangesDrawer = withShowToggle(
  <T extends BaseCandidate>({
    title,
    candidate,
    onClose,
    error,
    children,
    isOpen = false,
    loading = false
  }: ChangeDrawerProps<T>) => {
    const content = error ? (
      <ErrorNotification error={error} />
    ) : (
      <PreviewChanges candidate={candidate} loading={loading} />
    );

    return (
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        size="md"
        className="preview-changes-drawer"
      >
        <div className="on-click-outside-container">
          <Drawer.Heading>{title}</Drawer.Heading>
          <Drawer.Content>{content}</Drawer.Content>
          <Drawer.Footer>{children}</Drawer.Footer>
        </div>
      </Drawer>
    );
  }
);
